import { ReactNode } from "react";
import { View } from "./View";

export interface IOverflowMenuDropDownProps {
  children: ReactNode;
  focusTrap?: boolean;
  size?: string;
  flipped?: boolean;
  ariaLabel?: string;
  selectorPrimaryFocus?: string;

  renderIcon?: ReactNode;
  onClick?: (e: any) => void;
  onClose?: (e: any) => void;
  onOpen?: (e: any) => void;

  // controlled component
  open?: boolean;
}

export const OverflowMenuDropDown = (props: IOverflowMenuDropDownProps) => {
  return <View {...props} />;
};
